import {
    createFundingSource,
    getFundingSource,
    getFundingSourceById,
    getFoundingSourceServiceById,
    createFoundingSourceServiceById,
    editFundingSource,
    editFoundingSourceServiceById,
    createFundingModifier,
    editFundingModifier,
    changeFundingModifierStatus,
    changeFundingSourceStatus,
    setStatus,
    getServiceModifier,
    editFoundingSourceServiceStatus,
    deleteFundingSource,
    getFundingSourceClients,
    editFsSourceGrouping,
    removeFoundingSourceServices,
    getPayerCapabilities,
    addPayerEnrollment,
    changePayerEnrollmentStatus,
    editSupervisionRequirement,
    editCms1500Settings, fundingUniqueServices,
} from './fundingSource.action';
export { fundingSourceReducer } from './fundingSource.reducer';
export { watchFundingSource } from './fundingSource.saga';

export const fundingSourceActions = {
    /** Founding Source */
    createFundingSource,
    editFundingSource,
    editFsSourceGrouping,
    changeFundingSourceStatus,
    getFundingSource,
    getFundingSourceById,
    deleteFundingSource,
    getFundingSourceClients,
    getPayerCapabilities,
    /** End */

    /** Founding Source Service */
    createFoundingSourceServiceById,
    getFoundingSourceServiceById,
    removeFoundingSourceServices,
    editFoundingSourceServiceById,
    editFoundingSourceServiceStatus,
    /** End */

    /** Modifiers */
    getServiceModifier,
    createFundingModifier,
    editFundingModifier,
    changeFundingModifierStatus,
    /** End */

    setStatus,

    /** Enrollment */
    addPayerEnrollment,
    changePayerEnrollmentStatus,
    /** End */

    /** Supervision */
    editSupervisionRequirement,
    /** End */

    /** CMS 1500 Settings */
    editCms1500Settings,
    /** End */
    fundingUniqueServices,
};
